/**
 *   Transformar los resultados de error de formularios de Symfony a un
 * formato compatible con los errores de Formik
 */

export const translateSymfonyErrorToFormik = (obj) => {
    let newObj = {};
    Object.keys(obj).forEach((prop) => {
        const elem = obj[prop];

        if (Object.prototype.hasOwnProperty.call(elem, "errors")) {
            if (elem["errors"][0]) newObj[prop] = elem["errors"][0];
            else newObj[prop] = "Error";
        }
    });

    return newObj;
};

export const isNotValid = (response) => {
    return (
        Object.prototype.hasOwnProperty.call(response, "errors") &&
        Object.prototype.hasOwnProperty.call(response["errors"], "children")
    );
};

export const getGenericForSelect = (entities) => {
    return (entities || []).map((item) => {
        return { value: item.id, label: item.name };
    });
};

export const getGenericById = (list) => {
    return (list || []).reduce((acc, cur) => ({ ...acc, [cur.id]: cur }), {});
};

// https://gist.github.com/ghinda/8442a57f22099bdb2e34
//https://stackoverflow.com/questions/684672/how-do-i-loop-through-or-enumerate-a-javascript-object
//function objectToFormData(obj, form, namespace) {
var objectToFormData = function (obj, form, namespace) {
    var fd = form || new FormData();
    var formKey;

    for (var property in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, property)) {
            //if(obj.hasOwnProperty(property)) {

            if (namespace) {
                formKey = namespace + "[" + property + "]";
            } else {
                formKey = property;
            }

            // if the property is an object, but not a File,
            // use recursivity.
            if (typeof obj[property] === "object" && !(obj[property] instanceof File)) {
                objectToFormData(obj[property], fd, formKey);
            } else {
                // if it's a string or a File object
                fd.append(formKey, obj[property]);
            }
        }
    }

    return fd;
};

export { objectToFormData };
